import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeletePinnedViewMutation,
  DeletePinnedViewMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const deletePinnedView = graphql(`
  mutation DeletePinnedView($input: DeletePinnedSavedViewRequest!) {
    deletePinnedView(DeletePinnedSavedViewRequest: $input) {
      id
    }
  }
`);

export function useDeletePinnedView(
  options?: UseMutationOptions<
    DeletePinnedViewMutation,
    unknown,
    DeletePinnedViewMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(deletePinnedView, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["savedViews"] });
      await queryClient.refetchQueries({ queryKey: ["savedViews"] });
      await queryClient.invalidateQueries({ queryKey: ["pinnedViews"] });

      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });

  return { data: data?.deletePinnedView, ...rest };
}
